import { render, staticRenderFns } from "./ResolucionesNewOrEdit_OLD.vue?vue&type=template&id=b2bc604c&scoped=true&"
import script from "./ResolucionesNewOrEdit_OLD.vue?vue&type=script&lang=js&"
export * from "./ResolucionesNewOrEdit_OLD.vue?vue&type=script&lang=js&"
import style0 from "./ResolucionesNewOrEdit_OLD.vue?vue&type=style&index=0&id=b2bc604c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc604c",
  null
  
)

export default component.exports